export const actions = {
  GET_ALL_COLORES_LEGO_REQUESTED: 'GET_ALL_COLORES_LEGO_REQUESTED',
  GET_ALL_COLORES_LEGO_SUCCEEDED: 'GET_ALL_COLORES_LEGO_SUCCEEDED',
  GET_ALL_COLORES_LEGO_FAILED: 'GET_ALL_COLORES_LEGO_FAILED',

  GET_BY_ID_COLOR_LEGO_REQUESTED: 'GET_BY_ID_COLOR_LEGO_REQUESTED',
  GET_BY_ID_COLOR_LEGO_SUCCEEDED: 'GET_BY_ID_COLOR_LEGO_SUCCEEDED',
  GET_BY_ID_COLOR_LEGO_FAILED: 'GET_BY_ID_COLOR_LEGO_FAILED',

  INSERT_COLOR_LEGO_REQUESTED: 'INSERT_COLOR_LEGO_REQUESTED',
  INSERT_COLOR_LEGO_SUCCEEDED: 'INSERT_COLOR_LEGO_SUCCEEDED',
  INSERT_COLOR_LEGO_FAILED: 'INSERT_COLOR_LEGO_FAILED',

  UPDATE_COLOR_LEGO_REQUESTED: 'UPDATE_COLOR_LEGO_REQUESTED',
  UPDATE_COLOR_LEGO_SUCCEEDED: 'UPDATE_COLOR_LEGO_SUCCEEDED',
  UPDATE_COLOR_LEGO_FAILED: 'UPDATE_COLOR_LEGO_FAILED',

  UPDATE_RANGE_COLORES_LEGO_REQUESTED: 'UPDATE_RANGE_COLORES_LEGO_REQUESTED',
  UPDATE_RANGE_COLORES_LEGO_SUCCEEDED: 'UPDATE_RANGE_COLORES_LEGO_SUCCEEDED',
  UPDATE_RANGE_COLORES_LEGO_FAILED: 'UPDATE_RANGE_COLORES_LEGO_FAILED',

  DELETE_COLOR_LEGO_REQUESTED: 'DELETE_COLOR_LEGO_REQUESTED',
  DELETE_COLOR_LEGO_SUCCEEDED: 'DELETE_COLOR_LEGO_SUCCEEDED',
  DELETE_COLOR_LEGO_FAILED: 'DELETE_COLOR_LEGO_FAILED',

  SELECTED_COLOR_LEGO_BY_ID: 'SELECTED_COLOR_LEGO_BY_ID',
}

export const getColoresLegoAction = (dispatch, filter) => {
  dispatch({
    type: actions.GET_ALL_COLORES_LEGO_REQUESTED,
    payload: filter,
  })
}
export const getColorLegoByIdAction = (dispatch, filter) => {
  dispatch({
    type: actions.GET_BY_ID_COLOR_LEGO_REQUESTED,
    payload: filter,
  })
}
export const selectedColorLegoByIdAction = (dispatch, filter) => {
  dispatch({
    type: actions.SELECTED_COLOR_LEGO_BY_ID,
    payload: filter,
  })
}
export const insertColorLegoAction = (dispatch, filter) => {
  dispatch({
    type: actions.INSERT_COLOR_LEGO_REQUESTED,
    payload: filter,
  })
}
export const updateRangeColoresLegoAction = (dispatch, payload) => {
  dispatch({
    type: actions.UPDATE_RANGE_COLORES_LEGO_REQUESTED,
    payload,
  })
}

export const updateColorLegoAction = (dispatch, filter) => {
  dispatch({
    type: actions.UPDATE_COLOR_LEGO_REQUESTED,
    payload: filter,
  })
}
export const deleteColorLegoAction = (dispatch, filter) => {
  dispatch({
    type: actions.DELETE_COLOR_LEGO_REQUESTED,
    payload: filter,
  })
}
